import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SurveyUtilsService {
  // Helper method to create product charge description
  private getProductChargeDescription(productName: string, billRunDaterange: string, formTitle: string = ''): string {
    if (!productName) {
      if(billRunDaterange) {
        return `<strong>${billRunDaterange}</strong>`;
      }
      else if (formTitle) {
        return `<strong>Charges for ${formTitle}</strong>`;
      } 
      return `<strong>Form Charges</strong>`;
    }
    return `<strong>${productName} charges for period ${billRunDaterange}</strong>`;
  }

  getConfirmationChargesTable(charges: any, total: any, formatter: any, firstName: string, lastName: string, formTitle: string = '') {
    let title = 'Charge Summary for ' + firstName + ' ' + lastName;

    let processedData: {
      title: string;
      items: Array<{
        id: number;
        firstValue: string;
        secondValue: string;
        details: any[];
        detailsCount: number;
        showDetails: boolean;
      }>;
      columns: any[];
      showColumnsTitles: boolean;
      withExpandButton: boolean;
      footer: string;
    } = {
      title: title,
      items: [],
      columns: ['Description', 'Amount '],
      showColumnsTitles: true,
      withExpandButton: true,
      footer: '#prorated ^includes tax'
    };


  let detailId = 0;
  let isFirstItem = true;
  let actualItemName = '';
  let listOfItems: any[] = [];
  let listOfDetails: any[] = [];

  for(const fee of charges.fees) {
    const charge = parseFloat(fee.price) + parseFloat(fee.tax);
    const tax = fee.tax ? '^' : '';
    const currentItem = this.getProductChargeDescription(fee.product_name, fee.bill_run_daterange, formTitle);

    if(isFirstItem === true) {
      isFirstItem = false;
      actualItemName = this.getProductChargeDescription(fee.product_name, fee.bill_run_daterange, formTitle);
      listOfItems.push(actualItemName);
    }

    if(actualItemName !== currentItem) {
      detailId = 0;
      actualItemName = this.getProductChargeDescription(fee.product_name, fee.bill_run_daterange, formTitle);
      listOfItems.push(actualItemName);
    }

    let detail = {
      itemFirstValue: this.getProductChargeDescription(fee.product_name, fee.bill_run_daterange, formTitle),
      itemSecondValue: '',
      charge: charge,
      detailFirstValue: fee.description,
      detailSecondValue: formatter.format(charge) + (fee.prorated ? "#" : "") + tax,
      detailId: detailId++
    }

    listOfDetails.push(detail);
  }

  let itemId = 0;
  for(const item of listOfItems) {

    let details = listOfDetails.filter(d => d.itemFirstValue === item);
    let detailsToAdd = [];

    for(const detail of details) {
      let detailToAdd = {
        id: detail.detailId,
        firstValue: detail.detailFirstValue,
        secondValue: detail.detailSecondValue
      }
      detailsToAdd.push(detailToAdd);
    }

    let itemTotalCharges2 = 0;
    itemTotalCharges2 = listOfDetails.filter(d => d.itemFirstValue === item).reduce((acc, d) => acc + d.charge, 0);

    let itemToAdd = {
      id: itemId++,
      firstValue: item,
      secondValue: `<strong>${formatter.format(itemTotalCharges2)}</strong>`,
      details: detailsToAdd,
      detailsCount: details.length,
      showDetails: false
    };

    processedData.items.push(itemToAdd);
  }


    let totalItem: {
      id: number;
      firstValue: string;
      secondValue: string;
      details: any[];
      detailsCount: number;
      showDetails: boolean;
    } = {
      id: processedData.items.length + 1,
      firstValue: `<strong>Total</strong>`,
      secondValue: `<strong>${formatter.format(total)}</strong>`,
      details: [],
      detailsCount: 0,
      showDetails: false
    };
    processedData.items.push(totalItem);

    return processedData;
  }


  getOfficeListHtml(response: any): string {
    let html = `<style>
    .transition-election-card {
      background: white;
      padding: 15px;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      margin: auto;
    }
    .transition-election-header {
      display: flex;
      justify-content: space-between;
      align-items: left;
    }
    .transition-election-toggle-label {
      background: #1fd2c1;
      color: white;
      padding: 3px 13px;
      border-radius: 50%;
      cursor: pointer;
      height: 35px;
      width: 35px;
    }
    .transition-election-details {
      display: none;
      margin-top: 10px;
      border-top: 1px solid #ddd;
      padding-top: 10px;
    }

    input[type="checkbox"].transition-election {
      display: none;
    }

    input[type="checkbox"].transition-election:checked ~ .transition-election-details {
      display: block;
    }
  </style>
    `;
    for(const office of response) {
      let detailsHtml = '';

      for(const branch of office.branches) {
        detailsHtml += `
        <div>
          <p><strong>Office:</strong> [ID ${branch.office_nrds_id}] ${branch.business_name}</p>
          <p><strong>Designated Licensee:</strong> ${branch.dl_name} | <strong>Agents:</strong> ${branch.members_count}</p>
        </div>
        `
      }

      const cardHtml = `
        <div class="transition-election-card">
          <div class="transition-election-header">
              <div>
                  <p>[ID ${office.office_nrds_id}] ${office.business_name}</p>
                  <p>Branches: ${office.branches_count} | Agents:  ${office.members_count}</p>
              </div>
              ${office.branches && office.branches.length > 0 ? `<label for="transitionElectionToggleDetails" class="transition-election-toggle-label">+</label>` : ''}
          </div>
          <input class="transition-election" type="checkbox" id="transitionElectionToggleDetails">
          <div class="transition-election-details">
            ${detailsHtml}
          </div>
        </div>
      `
      html += cardHtml;
    }

    return html
  }
}
